// src/App.jsx
import { BrowserRouter, Routes, Route } from "react-router-dom";

import VoxShell from "@/layout/VoxShell";
import VoxDashboard from "@/pages/VoxDashboard";
import ControlRoom from "@/pages/ControlRoom";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<VoxShell />}>
          <Route path="/" element={<VoxDashboard />} />
          <Route path="/control-room" element={<ControlRoom />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
